import axios from 'axios';
import {Api_Root} from '../hostConfig';

//Baseline for API calls used in Sevices/api.js
const instance = axios.create({
    baseURL: Api_Root
});
export default instance;